import Breadcrumb from './breadcrumb.element.js';

// export * from "./breadcrumb.element.js";
export default Breadcrumb;

Breadcrumb.define('wje-breadcrumb', Breadcrumb);
